export default __webpack_public_path__ + "static/media/certifi-4.b799eda6.png";